var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"mobile-breadcumbs"},[_c('p',{staticClass:"breadcrumbs-txt"},[_vm._v(_vm._s(_vm.modifiedBreadcrumbs))])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7bafa66","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/layouts/MobileBreadcrumbsResults.vue
// module id = 533
// module chunks = 187